// extracted by mini-css-extract-plugin
export default {"container":"TeamCards_container__aBcyC","cardsGroup":"TeamCards_cardsGroup__Xcz5W","avatar":"TeamCards_avatar__7f4oE","card":"TeamCards_card__ii2Uj"};